import React, { FC } from 'react';

import { capitalize, formatOption } from '@src/util';
import { PreSelectedSelectField }   from '@src/types';
import { InteropService }         from '@src/services';
import { SelectField }            from '../../../components/forms';


const Dropdown: FC<PreSelectedSelectField> = ( props ) => {

    let options = InteropService.getTaskConstraintTypes( true )
                                .map( constraintTypeValue => {
                                    return formatOption(
                                        InteropService.getTaskConstraintTypeFromEnumValue( constraintTypeValue, true ),
                                        capitalize( InteropService.getTaskConstraintTypeStatement( constraintTypeValue ), true )
                                    );
                                } );

    return (
        <SelectField
            { ...props }
            options={ options }>
        </SelectField>
    );
};

Dropdown.defaultProps = {};

export { Dropdown as TimingConstraintDropdown }
